<span *ngIf="isLegacyIcon" [class]="uiClass">
  <img *ngIf="legacyIconSrc" [src]="legacyIconSrc" />
</span>
<i
  *ngIf="!isLegacyIcon"
  nz-icon
  [nzType]="uiType"
  [nzTheme]="uiTheme"
  [nzSpin]="uiSpin"
  [nzTwotoneColor]="uiTwotoneColor"
  [nzIconfont]="uiIconfont"
  [nzRotate]="uiRotate"
  ui-tooltip
  [uiTooltipTitle]="tooltipTitle | localize"
  [uiTooltipPlacement]="tooltipPosition"
  [uiTooltipOverlayClassName]="uiTooltipOverlayClassName"
  [uiTooltipOrigin]="tooltipOrigin">
</i>
